import { useLocale } from "@reco/shared/src/composables/useLocale";
import { createFeatureToggler } from "@reco/shared/src/features";
import { getRuntimeConfig } from "@reco/shared/src/runtime-config";
import { toValue } from "vue";

export const useFeatureToggle = (country?: string) => {
  const config = getRuntimeConfig();
  const isFeatureEnabled = createFeatureToggler(config.features, country || toValue(useLocale().country));
  return { isFeatureEnabled };
};
